import { VoucherPrintOrgHeading, VoucherPrintOrgAddress, VoucherPrintDepartmentFooter } from "./VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import { VOUCHER_INVOICE_TYPE_VALUE } from "app/common/LocalConst";
import { formatMoney, getDateTime, getPrintPatientCode, hideMiddleDigits } from "app/common/LocalFunction";
import { toVietnamese } from "app/common/utils/VNUtils";
import React, { memo } from "react";
import QrSurveySection from "app/common/Component/Print/QrSurveySection";

const PrintFormHeatReceipt = ({
  componentRef,
  dataVoucherFee,
  initialPatient,
  staffRevenues = [],
}) => {
  console.log("dataVoucherFee", dataVoucherFee);
  console.log("staffRevenues", staffRevenues);
  const totalValue =
    dataVoucherFee?.items?.length > 0 &&
    dataVoucherFee?.items?.reduce(
      (acc, curr) => {
        return {
          totalQuantity: acc.totalQuantity + (curr?.quantity || 0),
          totalPrice:
            acc.totalPrice + (curr?.price || 0) * (curr?.quantity || 0),
          totalAmount:
            acc.totalAmount + curr?.invoiceItem?.subAmountActuallyPaid,
          totalPaid: acc.totalPaid + curr?.invoiceItem?.subTotalBillPatientPaid,
          totalDebit:
            acc.totalDebit +
            (curr?.invoiceItem?.subAmountActuallyPaid -
              curr?.invoiceItem?.subTotalBillPatientPaid),
        };
      },
      {
        totalQuantity: 0,
        totalAmount: 0,
        totalPrice: 0,
        totalPaid: 0,
        totalDebit: 0,
      }
    );
  const namesText = Array.isArray(staffRevenues)
    ? staffRevenues?.map((item) => item?.staff?.staffName).join(" ; ")
    : "Không rõ";

  return (
    <PrintCommon ref={componentRef} marginPage="0mm" hidden={false}>
      <header className="printHeader w-100 flex justify-between print-voucher">
        <table className="table-layout-fixed">
          <div className="wraper-print">
            <div className="container-print" style={{ maxWidth: "343px" }}>
              <VoucherPrintOrgHeading department={dataVoucherFee?.department} />
              <VoucherPrintOrgAddress
                department={dataVoucherFee?.department}
                addressOverride={dataVoucherFee?.department?.organization?.name}
              />

              <div className="mt-5 text-center">
                <h4 style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Phiếu{" "}
                  {dataVoucherFee?.voucherInvoiceType ===
                    VOUCHER_INVOICE_TYPE_VALUE.Refund
                    ? "hoàn tiền"
                    : "thu"}
                </h4>
                <div className="center">
                  {getDateTime(dataVoucherFee?.voucherDate)}
                </div>
              </div>
              <div style={{ marginTop: "12px" }}>
                <table
                  className="info-print"
                  style={{
                    borderCollapse: "collapse",
                    fontSize: "12px",
                    lineHeight: "1.4",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          width: "40%",
                          fontWeight: "bold",
                          padding: "2px 6px",
                        }}
                      >
                        Số hóa đơn:
                      </td>
                      <td style={{ width: "60%", padding: "2px 6px" }}>
                        {dataVoucherFee?.code || "Chưa có mã"}
                      </td>
                    </tr>
                     <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Người nộp tiền:
                      </td>
                      <td style={{ padding: "2px 6px" }}>
                        {dataVoucherFee?.patient?.displayName || ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Mã KH:
                      </td>
                      <td style={{ padding: "2px 6px" }}>
                        {getPrintPatientCode(dataVoucherFee?.patient, initialPatient)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Số điện thoại:
                      </td>
                      <td style={{ padding: "2px 6px" }}>
                        {hideMiddleDigits(dataVoucherFee?.patient?.phoneNumber) || ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        NV tư vấn:
                      </td>
                      <td style={{ padding: "2px 6px" }}>{namesText}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Lý do:
                      </td>
                      <td style={{ padding: "2px 6px" }}></td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Đã thanh toán:
                      </td>
                      <td style={{ padding: "2px 6px" }}>
                        {formatMoney(dataVoucherFee?.amountPaid || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Số tiền -{" "}
                        {dataVoucherFee?.voucherInvoiceType ===
                          VOUCHER_INVOICE_TYPE_VALUE.Refund
                          ? "Chi"
                          : "Thu"}
                        :
                      </td>
                      <td style={{ padding: "2px 6px", fontWeight: "bold" }}>
                        {formatMoney(dataVoucherFee?.customerPaidAmount || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Còn lại:
                      </td>
                      <td style={{ padding: "2px 6px" }}>
                        {formatMoney(dataVoucherFee?.remainingDebt || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        (Viết bằng chữ):
                      </td>
                      <td style={{ padding: "2px 6px", fontStyle: "italic" }}>
                        {toVietnamese(dataVoucherFee?.customerPaidAmount || "")}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Ghi chú:
                      </td>
                      <td style={{ padding: "2px 6px" }}>
                        {dataVoucherFee?.note || ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Kèm theo:
                      </td>
                      <td style={{ padding: "2px 6px" }}></td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "2px 6px" }}>
                        Chứng từ gốc:
                      </td>
                      <td style={{ padding: "2px 6px" }}></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                className="mt-5"
                style={{ textAlign: "center", fontSize: "12px" }}
              >
                <div style={{ fontWeight: "bold" }}>Khách hàng</div>
                <div style={{ fontStyle: "italic" }}>
                  (Kí, ghi họ tên rõ ràng)
                </div>
                <div style={{ height: "90px" }}></div>
              </div>

              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    textTransform: "uppercase",
                  }}
                >
                  <span>
                    Đã nhận đủ số tiền viết bằng chữ :{" "}
                    {toVietnamese(dataVoucherFee?.customerPaidAmount || "")}
                  </span>
                </div>
                <div></div>
              </div>

              <div
                style={{
                  marginTop: "12px",
                  fontSize: "11px",
                  fontStyle: "italic",
                  color: "#000000",
                  lineHeight: "1.4",
                }}
              >
                Trung tâm Thẩm mỹ sẽ không hoàn lại tiền khi khách hàng tự ý ngưng dịch vụ, sẽ chuyển sang lấy sản phẩm hoặc dịch vụ khác
              </div>
              <QrSurveySection patient={dataVoucherFee?.patient} />
            </div>
          </div>
        </table>
      </header>
    </PrintCommon>
  );
};


export default memo(PrintFormHeatReceipt);
